import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';

import { LiftStatusStorage } from 'Utils/Storage';

import { useSelectedOrganization } from 'Providers/OrganizationProvider';

function OrganisationSelector() {
  const { selectedOrganization, setSelectedOrganizationId, organizations } =
    useSelectedOrganization();

  return (
    <Autocomplete
      // Removing the id disabled browser auto-fill
      // See: https://github.com/mui-org/material-ui/issues/18556
      // id="organisatie-search"
      options={organizations}
      sx={{ marginLeft: 1.5, marginRight: 1.5 }}
      value={selectedOrganization}
      autoHighlight
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;

        return (
          <li
            key={key}
            {...otherProps}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.name}
          </li>
        );
      }}
      onChange={(_, value: LiftStatus.Schemas.IOrganisation | null) => {
        LiftStatusStorage.organisationId = value ? value.id : null;
        setSelectedOrganizationId(value ? value.id : null);
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          variant="standard"
          {...params}
          label="Kies een organisatie"
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}

export default OrganisationSelector;
